document.addEventListener("DOMContentLoaded", function () {
  const promoBanner = document.querySelector(".promo__banner");
  const promoClose = document.querySelector("#close-promo-banner");

  if (!promoBanner) return;

  const isPopupExpired = () => {
    const savedTime = localStorage.getItem("popupTimestamp");
    if (!savedTime) return true;

    const oneDay = 24 * 60 * 60 * 1000;
    return Date.now() - savedTime > oneDay;
  };

  if (!localStorage.getItem("popupClosed") || isPopupExpired()) {
    promoBanner.classList.add("show");
    localStorage.setItem("popupTimestamp", Date.now());
  } else {
    promoBanner.remove();
    return;
  }

  if (promoClose) {
    promoClose.addEventListener("click", () => {
      promoBanner.classList.remove("show");

      localStorage.setItem("popupClosed", "true");
      localStorage.setItem("popupTimestamp", Date.now());

      setTimeout(() => {
        promoBanner.remove();

        // Let anything interested know the promo has disappeared
        window.dispatchEvent(new Event("promoClosed"));
      }, 300);
    });
  }
});